<template>
  <div>
    <div id="app" :style="[selectedTheme.vars, selectedBackground.vars]">
      <Nav :showNav="showNav" />
      <transition name="fade" mode="out-in">
        <keep-alive include="Logs">
          <router-view @showThankyou="showThankyou = true" @initAudio="initAudioHandler" @setAudioVolume="setAudioVolumeHandler" @setAudioMute="setAudioMuteHandler" />
        </keep-alive>
      </transition>
      <div id="frame"></div>
      <Footer :showFooter="showNav" />
    </div>
    <Thankyou :show="showThankyou" @hideThankyou="showThankyou = false" />
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex';

// import { Howl, Howler } from 'howler';

import Nav from '@/components/Nav';
import Footer from '@/components/Footer';
import Thankyou from '@/components/Thankyou';

export default {
  name: 'App',
  components: {
    Nav,
    Footer,
    Thankyou,
  },
  data() {
    return {
      showThankyou: false,
      backgroundAudio: null,
    }
  },
  watch: {
    selectedTheme(newVal) {
      document.documentElement.style.backgroundColor = newVal.vars['--secondary-color'];
    },
  },
  computed: {
    showNav() {
      // list of routes where nav should NOT show
      return ['landing', 'intro', 'welcome', 'setup', 'transition', 'outro'].includes(this.$route.name) === false;
    },
    ...mapState({
      audio: state => state.gameSettings.audio,
    }),
    ...mapGetters([
      'selectedTheme',
      'selectedBackground',
    ]),
  },
  methods: {
    initAudioHandler() {
      // if (!this.audio.muted) {
      //   this.backgroundAudio = new Howl({
      //     // src: ['groove.mp3'],
      //     src: [],
      //     autoplay: true,
      //     loop: true,
      //     volume: 0.5,
      //   });
      //   this.setAudioVolumeHandler(this.audio.volume);
      // }
    },
    setAudioMuteHandler(val) {
      this.setAudioMuted(val);
      this.saveState();
      if (this.backgroundAudio === null) {
        this.initAudioHandler();
      }
      this.backgroundAudio.mute(val);
    },
    setAudioVolumeHandler(val) {
      // Howler.volume(val);
      this.setAudioVolume(val);
      this.saveState();
    },
    ...mapMutations([
      'loadState',
      'setNewGame',
      'setAudioMuted',
      'setAudioVolume',
      'saveState',
    ]),
  },
  mounted() {
    const ls = JSON.parse(localStorage.getItem('lockdownProtocol'));
    if (ls !== null) {
      this.loadState(ls.state);
      this.setNewGame(false);
    }
  }
}
</script>

<style>
* {
  padding: 0;
  box-sizing: border-box;
  /* transition: background-color 0.2s, border 0.2s, color 0.2s, text-shadow 0.2s, box-shadow 0.2s; */
}

body {
  margin: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

html {
  background-color: #1d1d1d;
}

#app {
  background-color: var(--secondary-color);
  padding: 50px;
  width: 100%;
  min-height: 100%;
  position: absolute;

  background-image: var(--bg-image);
  border: 6px solid var(--primary-color);
}

h1, h2, h3, p, label, pre, a {
  color: var(--primary-color);
  font-family: 'Roboto Mono', monospace;
}

/* h1, h2, h3 {
  text-shadow: 0 0 10px var(--secondary-color), 0 0 5px var(--primary-color);
}

p, label, pre {
  text-shadow: 0 0 10px var(--secondary-color), 0 0 5px var(--primary-color);
} */

label {
  font-size: 13px;
  margin-bottom: 6px;
}

label::before {
  content: "_"
}

input, select {
  font-family: 'Roboto Mono', monospace;
  margin-top: 2px;
  display: block;
  margin-bottom: 10px;
  padding: 5px 8px;
  border-radius: 4px;
  border: 2px solid var(--primary-color);
  background: var(--secondary-color);
  color: var(--tertiary-color);
  font-size: 14px;
}

select {
  width: 420px;
}

input.radio {
  display: inline;
}

input.radio:checked {
  box-shadow: 0 0 30px var(--tertiary-color);
}

input.color {
  padding: 0;
  border: none;
  background-color: none;
  display: inline;
  margin-right: 10px;
}

textarea {
  resize: none;
  height: 150px;
  font-family: 'Roboto Mono', monospace;
  margin-top: 2px;
  display: block;
  margin-bottom: 10px;
  padding: 13px 13px;
  border-radius: 4px;
  border: 2px solid var(--primary-color);
  background: var(--secondary-color);
  color: var(--tertiary-color);
  font-size: 14px;
  width: 100%;
}

button {
  font-family: 'Roboto Mono', monospace;
  margin-top: 10px;
  display: block;
  margin-bottom: 10px;
  padding: 5px 8px;
  border-radius: 4px;
  border: 2px solid var(--tertiary-color);
  background: var(--primary-color);
  color: var(--secondary-color);
  font-size: 14px;
}

button:hover {
  cursor: pointer;
  box-shadow: 0 0 30px var(--tertiary-color);
}

button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  box-shadow: none !important;
}

input:focus, textarea:focus, select:focus, button:focus {
  box-shadow: 0 0 30px var(--tertiary-color);
  outline: none;
}

input[type=range]:focus {
  box-shadow: none;
  outline: none;
}

hr {
  overflow: visible; /* For IE */
  padding: 0;
  border: none;
  border-top: 1px dashed var(--primary-color);
  text-align: center;
  height: 0;
}

hr::after {
  content: "◆";
  display: inline-block;
  position: relative;
  top: -11px;
  color: var(--primary-color);
  padding: 0 0.25em;
}

.tertiary {
  color: var(--tertiary-color);
}

.wrapper {

}

#frame {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 6px solid var(--primary-color);
  pointer-events: none;
}

/* #frame > div:nth-child(1) {
  right: 12px;
  bottom: 12px;
  animation-delay: -0.5s;
  width: 20px;
  height: 20px;
}
#frame > div:nth-child(2) {
  right: 30px;
  animation-delay: -1s;
  width: 5px;
  height: 5px;
}
#frame > div:nth-child(3) {
  right: 45px;
  animation-delay: -1.5s;
} */

/* transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-up-enter-active, .fade-up-leave-active {
  transition: opacity .5s, transform 1s;
}
.fade-up-enter, .fade-up-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate(0, 10px);
}

.fade-up-d1-enter-active, .fade-up-d1-leave-active {
  transition: opacity .75s .5s, transform 1s .5s;
}
.fade-up-d1-enter, .fade-up-d1-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate(0, 10px);
}

.fade-up-d2-enter-active, .fade-up-d2-leave-active {
  transition: opacity .75s 1s, transform 1s 1s;
}
.fade-up-d2-enter, .fade-up-d2-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translate(0, 10px);
}

.fade-in {
  transition: opacity .5s, transform 1s;
}

.hidden {
  opacity: 0;
  transform: translate(0, 10px);
}

.visible {
  opacity: 1;
  transform: translate(0, 0);
}

.even {
  background-color: var(--primary-color-opacity);
}
</style>
